<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="number">Номер подъезда</label>
    <input
      type="text"
      class="form-control"
      id="number"
      placeholder="Введите номер подъезда"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'block-number-field',
  props: {
    value: [String, Number],
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockNumber.vue?23c00e21